import React, { createContext } from 'react';
import { Api } from '../api';
const DEFAULT_FETCH_POLICY = 'cache-and-fetch';
export const ApiContext = createContext({
    api: new Api(),
    defaultFetchPolicy: DEFAULT_FETCH_POLICY
});
export const ApiProvider = function ApiProvider(props) {
    return (React.createElement(ApiContext.Provider, { value: {
            api: props.api,
            defaultFetchPolicy: props.defaultFetchPolicy || DEFAULT_FETCH_POLICY
        } }, props.children));
};
//# sourceMappingURL=context.js.map